import axios from 'axios'

export default {
  /* Общие для организаций */
  editOrganization(organization) {
    return axios.post('/api/organizations/', organization)
  },
  removeOrganizations(organizations) {
    return axios.delete('/api/organizations/', {
      data: {
        organizations
      }
    })
  },
  getFilteredOrganizations(payload) {
    return axios.get('/api/organizations/filtered', {
      params: payload
    })
  },
  getOrganizationById(id) {
    return axios.get(`/api/organizations/${id}`)
  },

  /* Классы */
  getClasses(deleted = false) {
    const params = new URLSearchParams()
    if (deleted) { params.append('deleted', true) }
    return axios.get('/api/organizations/classes', { params })
  },
  addClass(classForAdd) {
    return axios.post('/api/organizations/classes/add', classForAdd)
  },

  /* Университеты и СПО */
  getUniversities() {
    return axios.get('/api/organizations/universities')
  },
  addUniversity(universityForAdd) {
    return axios.post('/api/organizations/universities/add', universityForAdd)
  },

  /* Подразделения  */
  getSubdivisions() {
    return axios.get('/api/organizations/subdivisions')
  },
  addSubdivision(subdivisionForAdd) {
    return axios.post('/api/organizations/subdivisions/add', subdivisionForAdd)
  }

}
